import { FunctionComponent } from 'react';
import { twMerge } from 'src/utils/twMerge';
import bgPatternUrl from 'src/assets/bg-pattern.svg';

type Props = { color?: string; className?: string; 'data-testid'?: string };

const BackgroundPattern: FunctionComponent<Props> = ({
  color,
  className,
  'data-testid': dataTestId,
}) => {
  return (
    <div
      data-testid={dataTestId}
      className={twMerge(
        'absolute inset-0 z-0 bg-repeat',
        !color && !className && 'bg-structural-darkest/[0.02]',
        className,
      )}
      style={{
        backgroundColor: color,
        mask: `url(${bgPatternUrl})`,
      }}
    />
  );
};

export default BackgroundPattern;
